const jsonSchema = [
  {
    type: 'group',
    fields: [
  {
    name: 'firstName',
    label: 'First Name',
    type: 'text',
    required: true,
    showInList: true
  },
  {
    name: 'lastName',
    label: 'Last Name',
    type: 'text',
    required: true,
    showInList: true
  }
    ]
  },
  {
    name: 'email',
    label: 'Email',
    type: 'email',
    required: true,
    showInList: true
  },
  {
    name:'wodMembershipPlan',
    label: 'Membership',
    type: 'multiselect',
    required:true,
    showInList: true
  }

  // Add more fields as needed
];
export default jsonSchema;
